var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcSeries(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5.61816,
    y: 18.5988,
    width: 13.7634,
    height: 1.40146,
    rx: 0.70073,
    fill: "#545454"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.1021 4H3.89785C3.12584 4 2.5 4.67974 2.5 5.51825V15.7956C2.5 16.6341 3.12584 17.3139 3.89785 17.3139H21.1021C21.8742 17.3139 22.5 16.6341 22.5 15.7956V5.51825C22.5 4.67974 21.8742 4 21.1021 4ZM4.13202 5.86958C4.13202 5.68931 4.26743 5.54317 4.43448 5.54317H20.5655C20.7326 5.54317 20.868 5.68931 20.868 5.86958V15.4443C20.868 15.6246 20.7326 15.7707 20.5655 15.7707H4.43448C4.26743 15.7707 4.13202 15.6246 4.13202 15.4443V5.86958Z",
    fill: "#545454"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSeries);
export default __webpack_public_path__ + "static/media/ic-series.46e37372224c3cf76bd21fefa8ffbbbe.svg";
export { ForwardRef as ReactComponent };